import React, { useState, useEffect, useMemo } from 'react';
import { useTranslation } from "react-i18next";
import { ButtonHLPure, DialogSystemGLPure, InputHLPure, PanelBarHLPure, PromotionalFooterPure, SimpleLoading, SubtitlePageHLPure, TextAreaHLPure, DialogYesNoHLPure, LabelModalPure, SignRequestDetailPure, ButtonPanelPure } from '../../pures';
import { Container, Grid, useMediaQuery } from '@material-ui/core';
import { Link } from "react-router-dom";
import { profileIconDefault } from '../../../assets/logos/icons';
import autografa from "../../../assets/logos/autografa.png";
import avanzada from "../../../assets/logos/avanzada.png";
import efirma from "../../../assets/logos/efirma.png";
import PdfViewerAction from '../../actions/pdf-viewer/pdf-viewer.action'
import DialogEditExpirationDate from "../../pures/signature-request-detail/dialog-edit-expiration-date";
import DialogAcceptSignatureESignature from "../../pures/signature-request-detail/dialog-accept-signature-e-firma";
import DialogAcceptSignatureElectronica from "../../pures/signature-request-detail/dialog-accept-signature-electronica";
import DialogRejectSignature from "../../pures/signature-request-detail/dialog-reject-signature";
import DialogAcceptSignatureAutografaCustom from "../../pures/signature-request-detail/dialog-accept-signature-autografa-custom";
import DialogResendSignatureRequest from "../../pures/dialog-resend-signature-request/dialog-resend-signature-request.pure";
import DialogReactivateSignatureRequest from "../../pures/dialog-reactivate-signature-request/dialog-reactivate-signature-request.pure";
import { ConservacionMensajeImage, EstampadoTiempoImage } from "../../../assets/logos/icons";
import { PDFDocument } from "pdf-lib";
import { useHistory } from 'react-router-dom';
import "./detail-signature.view.css";
import DialogAcceptSignatureAutografaCustomVolume from '../../pures/signature-request-detail/dialog-accept-signature-autograda-custom-volume';
import { DateTime } from "luxon";
import StandardDates from '../../../utils/StandardDates.util';
import { AIDocumentAnalysisAction } from '../../actions'

const DetailSignatureView = (props) => {

    const { t } = useTranslation();
    let history = useHistory();

    let {
        token,
        user,
        isLoadingView,
        showErrorRequesting,
        messageError,
        messageComplete,
        messageWarning,
        showLoadingRequesting,
        showCompletedRequesting,
        showWarningRequesting,
        toggleErrorRequesting,
        toggleLoadingRequesting,
        toggleCompletedRequesting,
        toggleWarningRequesting,
        toggleLoadingScreen,
        signatureRequestInfo,
        signatureRequestId,
        signatureTypes,
        createMessage,
        markChatAsRead,
        usersChat,
        conversation,
        membersChat,
        signers,
        userCanEditExpirationDate,
        expirationDate,
        onUpdateExpirationDate,
        toggleEditExpirationDate,
        signStatusName,
        signStatusColor,
        signRequestPDFURL,
        notifyClient,
        completedRequest,
        openDialog,
        setIsShowAutorizationModal,
        imgSignature,
        setImgSignature,
        signRequestPDF,
        onSubmit,
        showBtnNotify,
        idPrecharge,
        idVault,
        sendToDigitalVault,
        authorizerCanSign,
        userCanSign,
        toggleDialogResendSignatureRequest,
        onResendSignatureRequest,
        toggleDialogReactivateSignatureRequest,
        onReactivateSignatureRequest,
        signgRequestIsPackage,
        documentsPackage,
        showCancellationReason,
        cancellationReason,
        isShowAutorizationModal,
        authorize,
        titleHeader,
        showBtnNext,
        showBtnReject,
        labelBtnNext,
        labelBtnReject,
        nextImage,
        handleSubmit,
        handleReject,
        handleWarning,
        isCanceledOrRejected,
        isWarnign,
        onWarningClose,
        onWarningReturnInbox
    } = props

    const [currentSignaturetype, setCurrentSignaturetype] = useState({})
    const [signatureTypeImg, setSignatureTypeImg] = useState('')
    const [addIcons, setAddIcons] = useState([])
    const [nameSignature, setNameSignature] = useState('')
    const [comments, setComments] = useState('')
    const [signerSelectedGrid, setSignerSelectedGrid] = useState({})
    const [urlPdf, setUrlPdf] = useState("");
    const [dataGridDocumentsSign, setDataGridDocumentsSign] = useState([])
    const [documentSelectedGrid, setDocumentSelectedGrid] = useState({})
    const [filePdf, setFilePDF] = useState({});
    const [currentUser, setCurrentUser] = useState({});
    const [signatures, setSignatures] = useState([]);
    const [result, setResult] = useState(null);
    const [showPdfSignatures, setShowPdfSignatures] = useState(false);
    const [currentSystem, setCurrentSystem] = useState("");
    const [showBtnSendBoveda, setShowBtnSendBoveda] = useState(false)
    const [showBtnClasifyBoveda, setShowBtnClasifyBoveda] = useState(false)
    const [showTextSigns, setShowTextSigns] = useState(false)
    const [showIconProofOflife, setShowIconProofLife] = useState(false)
    const [showDialogAnalyzeIA, setShowDialogAnalyzeIA] = useState(false)

    const toggleShowPdfSignatures = () =>
        setShowPdfSignatures(!showPdfSignatures);

    const autographySignImg = props.signatureRequestInfo.autographySign ? "data:image/png;base64," + props.signatureRequestInfo.autographySign : null
    const pdf = useMemo(
        () => (
            <div style={{ height: "100%", position: 'relative' }}>
                {isCanceledOrRejected && !signRequestPDF ? (
                    <div className='detailSignatureView-pdf-cancelled-message'>
                        {t('detailSignatureView.documentDeletedByCancellation')}
                    </div>
                ) : (<PdfViewerAction
                    url={urlPdf}
                    isExtended={true}
                    isSSRActive={false}
                    customHeight="1119px"
                />)}
            </div>
        ),
        [urlPdf, isCanceledOrRejected, t]
    );

    useEffect(() => {
        if (isCanceledOrRejected && !signRequestPDF && !isWarnign && typeof handleWarning === 'function') {
            handleWarning()
        }
    }, [isCanceledOrRejected])

    let infodevice = currentSystem.toLowerCase();
    let isMobile = infodevice.includes("android");
    isMobile = isMobile || infodevice.includes("iphone");
    isMobile = isMobile || infodevice.includes("ipad");
    isMobile = isMobile || infodevice.includes("mobile");

    const is1366 = useMediaQuery("(max-width:1366px)");
    const is650 = useMediaQuery("(max-width: 650px)")
    const is560 = useMediaQuery("(max-width:560px)");

    let showColumnRol = false
    let showColumnStatus = true


    if (is1366) {
        showColumnStatus = false
    }

    const numSign = currentUser.numSign || 1;

    const headerColumnOneItem1 = (props) => {
        return <span className="newSignatureDetailView-header-cell-one-item-1">{props.title}</span>;
    };

    const headerColumnTwoItem1 = (props) => {
        return <span className="newSignatureDetailView-header-cell-two-item-1">{props.title}</span>;
    };

    const headerColumnOneItem2 = (props) => {
        return <span className="newSignatureDetailView-header-cell-one-item-2">{props.title}</span>;
    };

    const cellColumnOneItem1 = (props) => {
        return (
            <td className='newSignatureDetailView-cell-one-item-1'>
                <div className="newSignatureDetailView-labels-column1-item1">
                    <p className='newSignatureDetailView-title-column1-item1'>
                        {props.dataItem.name}
                    </p>
                    <p className="newSignatureDetailView-subtitle-column1-item1"
                        style={is1366 ? { color: props.dataItem.color, fontWeight: 600 } : {}}>
                        {!is1366 ? props.dataItem.email : t(`detailSignatureView.status.${props.dataItem.signStatusName}`)}
                    </p>
                </div>
            </td>
        );
    };

    const cellColumnTwoItem1 = (props) => {
        return (
            <td className="newSignatureDetailView-cell-one-item-2">
                <div className="newSignatureDetailView-container-column2-item1">
                    <p className='newSignatureDetailView-title-column2-item1'>
                        {props.dataItem.signerTypeName}
                    </p>
                </div>
            </td>
        )
    }

    const cellColumnThreeItem1 = (props) => {
        return (
            <td className="">
                <div className="newSignatureDetailView-container-column2-item1">
                    <p className='newSignatureDetailView-title-column2-item1' style={{ color: props.dataItem.color }}>
                        {t(`detailSignatureView.status.${props.dataItem.signStatusName}`)}
                    </p>
                </div>
            </td>
        )
    }

    let styleTextTitleItem1 = {
        color: '#62789C',
        fontSize: '14px',
        fontFamily: 'Quicksand',
        fontStyle: 'normal',
        fontWeight: 600,
        padding: 0,
        margin: 0
    }


    const cellColumnOneItem2 = (props) => {
        return (
            <td className="newSignatureDetailView-cell-one-item-2">
                <div className="newSignatureDetailView-labels-column1-item1">
                    <p className='newSignatureDetailView-title-column1-item1'>
                        {props.dataItem.documentName}
                    </p>
                    <p className='newSignatureDetailView-subtitle-column1-item1'>
                        {props.dataItem.fileName}
                    </p>
                </div>
            </td>
        );
    };

    useEffect(() => {
        if (!signatureRequestInfo || !signatureRequestInfo.signRequest) return
        let name = signatureRequestInfo.signRequest.name
        let comments = signatureRequestInfo.signRequest.comments

        if (signgRequestIsPackage && documentsPackage && documentsPackage.length > 0) {
            documentsPackage = documentsPackage.sort((a, b) => {
                if (a.documentName < b.documentName) return -1
                if (a.documentName > b.documentName) return 1
                return 0
            })
            setDataGridDocumentsSign(documentsPackage)
        }

        setNameSignature(name)
        setComments(comments)
    }, [signatureRequestInfo])

    useEffect(() => {
        if (!signatureRequestInfo || !signatureRequestInfo.signRequest || !signatureTypes || !signatureTypes.length === 0) return
        let signatureType = signatureTypes.find((type) => type.id === signatureRequestInfo.signRequest.signatureTypeId)
        let signatureImg = ''
        /** @type {"top" | "bottom" | "left" | "right"} */
        let iconPosition = 'top'
        let iconDesc = ""
        let iconTitle = t("requestSignatureDetailView.SignatureType")
        switch (signatureType.id) {
            case 1:
                signatureImg = efirma
                break;
            case 2:
                signatureImg = avanzada
                break;
            case 3:
                if (props.userMultipleSign) {
                    signatureImg = `${process.env.REACT_APP_AWS_S3_BUCKET_URL}microservices/MiFirma/assets/inbox/iconoFirma2.svg`
                    iconDesc = t("signatureRequestDetailView2.multiplesSigns.tooltip.description")
                    iconPosition = 'left'
                    iconTitle = t("signatureRequestDetailView2.multiplesSigns")
                }
                else signatureImg = autografa
                break;
            default:
                signatureImg = autografa
                break;
        }

        let icons = []
        let services = signatureRequestInfo.servicesInSignsRequest
        services = [...new Map(services.map(item => [item.service.id, item])).values()];
        services.map((service) => {
            let icon = {}
            let serviceIcon = ConservacionMensajeImage;
            if (
                service.service.id ===
                Number(
                    process.env
                        .REACT_APP_ADDITIONAL_SERVICES_TIME_DOCUMENT
                )
            )
                serviceIcon = EstampadoTiempoImage;
            if (
                service.service.id ===
                Number(
                    process.env
                        .REACT_APP_ADDITIONAL_SERVICES_TIME_BY_SIGNATURE
                )
            )
                serviceIcon = EstampadoTiempoImage;
            icon.name = service.service.name
            icon.description = ''
            icon.img = serviceIcon
            icon.position = iconPosition
            icons.push(icon)
            return service
        })

        let icon = {}
        icon.name = iconTitle
        icon.description = iconDesc || signatureType.name
        icon.img = signatureImg
        icon.position = iconPosition
        icons.push(icon)

        let textSignsWatchUntilEnd = ((signatureRequestInfo.signRequest.signatureTypeId !== 3 && !isMobile) && (signatureRequestInfo.signRequest.signRequestStatus.name === 'Pendiente')) ? true : false

        let showIconProofOflife = false
        let proofOfLifeExist = signatureRequestInfo.signersList.some(signer => signer.proofOfLife)
        if (proofOfLifeExist) {
            showIconProofOflife = true
            let icon = {}
            icon.name = process.env.REACT_APP_PROOF_OF_LIFE_NAME
            icon.description = ''
            icon.img = `${process.env.REACT_APP_AWS_S3_BUCKET_URL}microservices/MiFirma/assets/inbox/icono_prueba_de_vida.svg`
            icon.position = 'top'
            icons.push(icon)
        }

        let showIconSignaturesMultiple = (signatureRequestInfo && signatureRequestInfo.inbox && signatureRequestInfo.inbox.solicitudeHasMultipleSignatures) ? true : false
        if (showIconSignaturesMultiple) {
            icons = icons.filter((icon) => icon.name !== 'Tipo de firma')
            let icon = {}
            icon.name = t("signatureRequestDetailView2.tooltip.signtures.multiples.title")
            icon.description = t("signatureRequestDetailView2.tooltip.signtures.multiples.description")
            icon.img = `${process.env.REACT_APP_AWS_S3_BUCKET_URL}microservices/MiFirma/assets/inbox/iconoFirma2.svg`
            icon.position = 'top'
            icons.push(icon)
        }

        setShowTextSigns(textSignsWatchUntilEnd)
        setSignatureTypeImg(signatureImg)
        setCurrentSignaturetype(signatureType)
        setAddIcons(icons)
        setShowIconProofLife(showIconProofOflife)
    }, [signatureRequestInfo, signatureTypes])

    useEffect(() => {
        if (!signRequestPDFURL || signRequestPDFURL === '') return
        setUrlPdf(signRequestPDFURL)
    }, [signRequestPDFURL])

    useEffect(() => {
        if (!props.currentUser || !props.currentUser.email) return
        setCurrentUser(props.currentUser);
        let tempArr = [];
        for (let index = 0; index < props.currentUser.numSign; index++) {
            tempArr.push({ date: null, index: index + 1, page: "" });
        }
        setSignatures(tempArr);
    }, [props.currentUser]);

    useEffect(() => {
        createPdf();
    }, [signatures]);

    useEffect(() => {
        setCurrentSystem(navigator.userAgent);
    }, []);

    useEffect(() => {
        if (!signatureRequestInfo || !signatureRequestInfo.signRequest || !signatureRequestInfo.signRequest.signRequestStatus || idVault === 0) return
        let showSend = (signatureRequestInfo.signRequest.signRequestStatus.id === Number(process.env.REACT_APP_SIGN_REQUEST_STATUS_COMPLET) && idPrecharge === null && (idVault === 14 || idVault === 15)) ? true : false
        let showClasify = (signatureRequestInfo?.signRequest?.signRequestStatus?.id === Number(process.env.REACT_APP_SIGN_REQUEST_STATUS_COMPLET) && idPrecharge !== null && idPrecharge !== undefined) ? true : false
        //Validacion de quitar el boton de enviar a boveda para algunos clientIds

        showSend = false
        showClasify = false
        setShowBtnSendBoveda(showSend)
        setShowBtnClasifyBoveda(showClasify)
    }, [signatureRequestInfo, idPrecharge, idVault])

    useEffect(() => {
        if (!signerSelectedGrid || !signerSelectedGrid.signRequestId || !is560) return
        notifyClient(signerSelectedGrid)
    }, [signerSelectedGrid])

    useEffect(() => {
        if (!documentSelectedGrid || !documentSelectedGrid.documentPathURL || !is560) return
        onHandleWathcDoc(documentSelectedGrid)
    }, [documentSelectedGrid])

    const createPdf = () => {
        let signatureData = signatures.map((i, j) => ({
            x: i.x,
            y: i.y,
            width: i.width,
            height: i.height,
            page: i.page,
            isMobile: true,
            fileSignImage: i.fileSignImage,
            imgSignature: i.imgSignature,
            fileName: `sign${j + 1}`,
        }));
        props.setSignatures(signatureData);
        insertSignByCoordinates(signatureData);
    };

    const insertSignByCoordinates = async (signatureData) => {
        if (!!signatureData.find((i) => i.imgSignature)) {
            const existingPdfBytes = await fetch(
                "data:application/pdf;filename=data.pdf;base64," + signRequestPDF
            ).then((res) => res.arrayBuffer());
            const pdfDoc = await PDFDocument.load(existingPdfBytes);
            const pages = pdfDoc.getPages()
            for (let index = 0; index < signatureData.length; index++) {
                const { x, y, width, height, page, isMobile, imgSignature } =
                    signatureData[index];
                if (imgSignature) {
                    const fileSignImage = await fetch(imgSignature).then((res) =>
                        res.arrayBuffer()
                    );
                    const pageToSign = page <= 0 ? pages[0] : pages[page - 1];
                    const heightPage = pageToSign.getHeight();
                    const pngSignImage = await pdfDoc.embedPng(fileSignImage);
                    pngSignImage.scale(1);
                    pageToSign.drawImage(pngSignImage, {
                        x,
                        y: isMobile ? y : heightPage - y - height,
                        width,
                        height,
                    });
                }
            }
            const pdfBytes = await pdfDoc.saveAsBase64();
            let elnuevopdf =
                "data:application/pdf;filename=data.pdf;base64," + pdfBytes;
            setResult(elnuevopdf);
        }
    };

    const onHandleWathcDoc = (documento) => {
        setUrlPdf(documento.documentPathURL)
    }

    const handleInputChangeChat = (e) => {
        let file = e.target.files[0];
        setFilePDF(file);
    };

    const onHandleBack = () => {
        history.goBack()
    }

    const handleOpenAnalyzeIA = () => {
        setShowDialogAnalyzeIA(true)
    }

    const handleCloseAnalyzeIA = () => {
        setShowDialogAnalyzeIA(false)
    }

    // Extraer signDocumentId y URL del primer documento
    const firstSignDocument = signatureRequestInfo?.signRequest?.signDocuments?.[0]
    const signDocumentId = firstSignDocument?.id || null
    const signDocumentUrl = firstSignDocument?.documentPathURLBase64 || null

    // Usar la URL y base64 del PDF principal para el modal de análisis IA
    const pdfUrlForIA = signRequestPDFURL || urlPdf
    const pdfBase64ForIA = signRequestPDF || null

    const buttons = [
        {
            show: true,
            action: () => onHandleBack(),
            image: `${process.env.REACT_APP_AWS_S3_BUCKET_URL}${process.env.REACT_APP_ICONS_SIGN_REQUEST_BACK}`,
            label: t('button.return')
        },
        {
            show: user?.userMetaData?.userMifirma?.userType?.id !== Number(process.env.REACT_APP_USER_TYPE_INVITADO) && !isCanceledOrRejected,
            action: () => handleOpenAnalyzeIA(),
            image: `${process.env.REACT_APP_AWS_S3_BUCKET_URL}${process.env.REACT_APP_ICONS_FILEMANAGER_TOOLBAR_ANALYZE}`,
            label: t('documentPanelActions.analyzeIA')
        },
        {
            show: showBtnReject,
            action: () => handleReject(),
            image: `${process.env.REACT_APP_AWS_S3_BUCKET_URL}${process.env.REACT_APP_ICONS_SIGN_REQUEST_REJECT}`,
            label: t(labelBtnReject)
        },
        {
            show: showBtnNext,
            action: () => handleSubmit(),
            image: nextImage,
            label: t(labelBtnNext)
        }
    ]

    return (
        <div className="standard-wrapper">
            {
                isLoadingView ? (
                    <SimpleLoading />
                )
                    : (
                        <Container
                            xs={12}
                            lg={12}
                            md={12}
                            sm={12}
                            spacing={4}
                            className="detailSignatureView-container"
                        >
                            <Grid
                                container
                                className="detailSignatureView-body"
                                xs={12}
                                lg={12}
                                md={12}
                                sm={12}
                                es={12}
                            >
                                <SignRequestDetailPure
                                    data={signatureRequestInfo}
                                    cancellationReason={cancellationReason}
                                    includesMessageCertificate={props.includesMessageCertificate}
                                    showCancellationReason={showCancellationReason}
                                    statusColor={signStatusColor}
                                    status={t(`detailSignatureView.status.${signStatusName}`)}
                                    userMultipleSign={props.userMultipleSign}
                                />
                                <ButtonPanelPure buttons={buttons} />
                                <div className='detailSignatureView-container-panelBars-pdf'>
                                    <PanelBarHLPure
                                        disabledChat={(() => {
                                            const CANCEL = Number(process.env.REACT_APP_SIGN_REQUEST_STATUS_CANCEL)
                                            const REJECT = Number(process.env.REACT_APP_SIGN_REQUEST_STATUS_REJECT)
                                            const currentId = signatureRequestInfo?.signRequest?.signRequestStatus?.id
                                            return [CANCEL, REJECT].includes(currentId)
                                        })()}
                                        styleGeneral1={true}
                                        styleGeneralClass1={"newSignatureDetailView-general-grid"}
                                        styleGeneral2={true}
                                        styleGeneralClass2={"newSignatureDetailView-general-grid-2"}
                                        titleItem1={t("newSignatureDetailView.signers")}
                                        titleItem2={t("newSignatureDetailView.documents.to.sign")}
                                        titleItem3={t("newSignatureDetailView.comments.team")}
                                        titlePanel={t("newSignatureDetailView.comments.binnacle")}
                                        expandedItem1={true}
                                        expandedItem2={true}
                                        expandedItem3={true}
                                        dataItem1={signers}
                                        setSelectedItem1={setSignerSelectedGrid}
                                        styleTextTitleItem1={styleTextTitleItem1}
                                        columnTwoItem1={showColumnRol}
                                        columnThreeItem1={showColumnStatus}
                                        columnFourItem1={false}
                                        columnFiveItem1={showBtnNotify}
                                        titleRow1Item1={t("newSignatureDetailView.column.name")}
                                        titleRow2Item1={t("newSignatureDetailView.column.rol")}
                                        titleRow3Item1={t("newSignatureDetailView.column.status")}
                                        titleRow4Item1={''}
                                        titleRow5Item1={t("newSignatureDetailView.column.actions")}
                                        headerColumnOneItem1={headerColumnOneItem1}
                                        headerColumnTwoItem1={headerColumnTwoItem1}
                                        headerColumnThreeItem1={headerColumnTwoItem1}
                                        headerColumnFourItem1
                                        cellColumnOneItem1={cellColumnOneItem1}
                                        cellColumnTwoItem1={cellColumnTwoItem1}
                                        cellColumnThreeItem1={cellColumnThreeItem1}
                                        cellColumnFourItem1
                                        textTitleItem1={t("newSignatureDetailView.signers.authorizers")}
                                        textDateLimit={t("newSignatureDetailView.date.limit")}
                                        iconOneActiveItem1={false}
                                        iconTwoActiveItem1={false}
                                        iconThirdActiveItem1={false}
                                        iconFourthActiveItem1={false}
                                        labelOneActionsItem1={'Notificar'}
                                        labelTwoActionsItem1={''}
                                        labelThirdActionsItem1={''}
                                        labelFourthActionsItem1={''}
                                        activeDialog1Item1={true}
                                        btnOpenDialog1Item1={(dataItem) => notifyClient(dataItem)}
                                        labelBtnDate={t("newSignatureDetailView.edit.date.limit")}
                                        handleBtnDate={toggleEditExpirationDate}
                                        dataItem2={dataGridDocumentsSign}
                                        setSelectedItem2={setDocumentSelectedGrid}
                                        setNameComponentUserItem1={() => console.log('')}
                                        setShowDetailsItem1={() => console.log('')}
                                        columnTwoItem2={false}
                                        columnThreeItem2={false}
                                        columnFourItem2={false}
                                        columnFiveItem2={true}
                                        titleRow1Item2={t("newSignatureDetailView.column.name")}
                                        titleRow2Item2={''}
                                        titleRow3Item2={''}
                                        titleRow4Item2={''}
                                        titleRow5Item2={t("newSignatureDetailView.column.actions")}
                                        headerColumnOneItem2={headerColumnOneItem2}
                                        setNameComponentUserItem2={() => console.log('')}
                                        setShowDetailsItem2={() => console.log('')}
                                        cellColumnOneItem2={cellColumnOneItem2}
                                        iconOneActiveItem2={true}
                                        iconTwoActiveItem2={false}
                                        iconThirdActiveItem2={false}
                                        iconFourthActiveItem2={false}
                                        labelOneActionsItem2={t("newSignatureDetailView.view.document")}
                                        labelTwoActionsItem2={''}
                                        labelThirdActionsItem2={''}
                                        labelFourthActionsItem2={''}
                                        activeDialog1Item2={true}
                                        btnOpenDialog1Item2={(dataItem) => onHandleWathcDoc(dataItem)}
                                        usersChat={usersChat}
                                        conversation={conversation}
                                        handleInputChangeChat={(e) => handleInputChangeChat(e)}
                                        createMessage={createMessage}
                                        onMarkAsRead={markChatAsRead}
                                        membersChat={membersChat}
                                        userCanEditExpirationDate={userCanEditExpirationDate}
                                        expirationDate={StandardDates.fromISOToStandardDate(expirationDate)}
                                        showTextSigns={showTextSigns}
                                        showBarItem2={signgRequestIsPackage}
                                        takeItem1={signers.length}
                                        pageableItem1={false}
                                        styleGridItem1={{ height: '316px' }}
                                        pageableItem2={false}
                                        takeItem2={dataGridDocumentsSign.length}
                                        styleGridItem2={{ height: '316px' }}
                                        titleChat={t('newSignatureDetailView.chatWithParticipants')}
                                    />
                                    <div className='detailSignatureView-container-pdf'>
                                        <Grid
                                            item
                                            lg={12}
                                            md={12}
                                            sm={12}
                                            xs={12}
                                            className="detailSignatureView-pdf"
                                        >
                                            {!showDialogAnalyzeIA ? pdf : <div className='detailSignatureView-pdf-placeholder'></div>}
                                        </Grid>
                                    </div>
                                </div>
                                <div className='detailSignatureView-container-btns'>
                                    <ButtonHLPure
                                        nameBtn={t("button.return")}
                                        onClickBtn={() => onHandleBack()}
                                        primary={false}
                                    />
                                    {
                                        showBtnReject && (
                                            <ButtonHLPure
                                                nameBtn={t(labelBtnReject)}
                                                onClickBtn={() => handleReject()}
                                                primary={false}
                                            />
                                        )
                                    }


                                    {
                                        !is650 && showBtnNext && (
                                            <ButtonHLPure
                                                nameBtn={t(labelBtnNext)}
                                                onClickBtn={() => handleSubmit()}
                                                primary={true}
                                            />
                                        )}

                                    {
                                        is650 && <Link
                                            to={{
                                                pathname: `/document-tracking/${signatureRequestInfo.signRequest.id}`,
                                                params: { dataItem: signatureRequestInfo.inbox },
                                            }}
                                            style={{ textDecoration: "none", display: "contents" }}
                                        >
                                            <ButtonHLPure
                                                nameBtn={t("signatureRequestDetailView2.buttonDocumentTracking")}
                                                onClickBtn={props.scrollWindow}
                                            />
                                        </Link>
                                    }


                                    <DialogResendSignatureRequest
                                        {...props}
                                        toggleDialogResendSignatureRequest={
                                            toggleDialogResendSignatureRequest
                                        }
                                        onResendSignatureRequest={
                                            onResendSignatureRequest
                                        }

                                        signatureRequest={signatureRequestInfo}
                                        signRequest={signatureRequestInfo.signRequest}
                                    />
                                </div>
                                {(userCanSign === true || authorizerCanSign === true) ? (
                                    <div className='detailSignatureView-btn-reject'>
                                        <DialogRejectSignature {...props} signatureRequest={signatureRequestInfo} />
                                    </div>
                                ) : null
                                }

                                {is650 ? (

                                    showBtnNext && (
                                        <ButtonHLPure
                                            nameBtn={t(labelBtnNext)}
                                            onClickBtn={() => handleSubmit()}
                                            primary={true}
                                        />
                                    )
                                ) : null}

                                <DialogAcceptSignatureESignature
                                    {...props}
                                    setIsShowAutorizationModal={setIsShowAutorizationModal}
                                    imgSignature={imgSignature}
                                    setImgSignature={setImgSignature}
                                    currentSignaturetype={currentSignaturetype ?? {}}
                                    signatureRequest={signatureRequestInfo}

                                />
                                <DialogAcceptSignatureElectronica
                                    {...props}
                                    setIsShowAutorizationModal={setIsShowAutorizationModal}
                                    imgSignature={imgSignature}
                                    setImgSignature={setImgSignature}
                                    currentSignaturetype={currentSignaturetype ?? {}}
                                    signatureRequest={signatureRequestInfo}

                                />
                                {
                                    (signatureRequestInfo && signatureRequestInfo.signRequest && signatureRequestInfo.signRequest.signRequestByVolumeId) ?
                                        (
                                            <DialogAcceptSignatureAutografaCustomVolume
                                                {...props}
                                                setIsShowAutorizationModal={
                                                    setIsShowAutorizationModal
                                                }
                                                imgSignature={imgSignature}
                                                setImgSignature={setImgSignature}
                                                currentSignaturetype={currentSignaturetype ?? {}}
                                                signatureRequest={signatureRequestInfo}
                                                signatures={signatures}
                                                setSignatures={setSignatures}
                                                setAllSignatures={props.setSignatures}
                                            />
                                        ) : (
                                            <DialogAcceptSignatureAutografaCustom
                                                {...props}
                                                noRenderSign={true}
                                                signatures={signatures}
                                                currentUser={currentUser}
                                                setIsShowAutorizationModal={
                                                    setIsShowAutorizationModal
                                                }
                                                imgSignature={imgSignature}
                                                setImgSignature={setImgSignature}
                                                currentSignaturetype={currentSignaturetype}
                                                signatureRequest={signatureRequestInfo}

                                                result={result}
                                                setSignatures={setSignatures}
                                                setAllSignatures={props.setSignatures}
                                                insertSignByCoordinates={insertSignByCoordinates}
                                                toggleLoadingRequesting={props.toggleLoadingRequesting}

                                                autographySign={autographySignImg}
                                            />
                                        )
                                }

                                {/*    <DialogReactivateSignatureRequest
                                    {...props}
                                    toggleDialogReactivateSignatureRequest={
                                        toggleDialogReactivateSignatureRequest
                                    }
                                    onReactivateSignatureRequest={
                                        onReactivateSignatureRequest
                                    }
                                    signatureRequest={signatureRequestInfo}
                                    signRequest={signatureRequestInfo.signRequest}
                                /> */}
                                {showBtnSendBoveda ? (
                                    <React.Fragment>
                                        <ButtonHLPure
                                            nameBtn={t("btn.send.boveda")}
                                            onClickBtn={() => {
                                                sendToDigitalVault(signatureRequestInfo.signRequest.id);
                                            }}
                                        />
                                    </React.Fragment>
                                ) : null}
                                {showBtnClasifyBoveda ? (
                                    <Link to={{ pathname: "/digital-vault-grc", state: { idPrecarga: idPrecharge } }}>
                                        <React.Fragment>
                                            <ButtonHLPure
                                                nameBtn={t("btn.clasify.boveda")}
                                            />
                                        </React.Fragment>
                                    </Link>
                                ) : null}

                                <Grid item xs={12} lg={12} md={12} sm={12}>
                                    <PromotionalFooterPure />
                                </Grid>
                            </Grid>
                            <div className='detailSignatureView-dialog-date'>
                                <DialogEditExpirationDate
                                    expirationDate={expirationDate}
                                    visibleExpirationDate={props.visibleExpirationDate}
                                    validator={props.validator}
                                    dateLimitTypeDate={props.dateLimitTypeDate}
                                    toggleEditExpirationDate={toggleEditExpirationDate}
                                    onUpdateExpirationDate={onUpdateExpirationDate}
                                />
                            </div>
                            <DialogSystemGLPure
                                showConfirm={isShowAutorizationModal}
                                confirmTitle={t('button.authorizeApplication')}
                                confirmMessage={t('signatureRequestDetailView2.modalquestion')}
                                labelCancelConfirmation={t('button.cancel')}
                                handleConfirmDeleteFlowClose={() => setIsShowAutorizationModal()}
                                labelSubmitConfirmation={t('button.authorize')}
                                handleConfirmDeleteFlowSubmit={() => authorize()}
                                showLoadingRequesting={showLoadingRequesting}
                                showCompletedRequesting={showCompletedRequesting}
                                showErrorRequesting={showErrorRequesting}
                                showWarningRequesting={showWarningRequesting}
                                toggleLoadingRequesting={toggleLoadingRequesting}
                                toggleCompletedRequesting={toggleCompletedRequesting}
                                toggleErrorRequesting={toggleErrorRequesting}
                                toggleWarningRequesting={toggleWarningRequesting}
                                message={messageError}
                                messageComplete={messageComplete}
                                messageWarning={messageWarning}
                                isWarnign={isWarnign}
                                labelWarningBtnCancel={t('button.close')}
                                labelWarningBtnSubmit={t('button.return')}
                                handleWarningClose={onWarningClose}
                                handleWarningSubmit={onWarningReturnInbox}
                                showBtnCancelWarning={isCanceledOrRejected && !signRequestPDF}
                                showBtnSubmitWarning={isCanceledOrRejected && !signRequestPDF}
                            />

                            {showDialogAnalyzeIA && (
                                <AIDocumentAnalysisAction
                                    showDialog={showDialogAnalyzeIA}
                                    documentData={{ name: signatureRequestInfo?.signRequest?.name || nameSignature }}
                                    documentUrl={pdfUrlForIA}
                                    selectedFileBase64={pdfBase64ForIA}
                                    signDocumentId={signDocumentId}
                                    signDocumentUrl={signDocumentUrl}
                                    onClose={handleCloseAnalyzeIA}
                                />
                            )}
                        </Container>
                    )
            }
        </div>
    )
}

export default DetailSignatureView